import { defineComponent } from 'vue';
import { ElMessageBox, ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message-box/style/css';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.array.push.js";
import { getCurrentInstance } from 'vue';
import InputFile from './inputFile.vue';
import Progress from './progress.vue';
import { upload } from '@/api/common';
import { saveRoleInfoDetails, roleDetail, saveMacChatMessage, delRoleInfoDetails, getFilePort } from '@/api/role';
import { useStore } from 'vuex';
import roleHooks from '@/hooks/roleHooks';
import userHooks from '@/hooks/userHooks';
import { deleteSession } from '@/api/chat';
import w from '@/assets/images/leftSlide/w.png';
import no from '@/assets/images/leftSlide/no.png';
import d from '@/assets/images/leftSlide/d.png';
import pdf from '@/assets/images/leftSlide/pdf.png';
import txt from '@/assets/images/leftSlide/txt.png';
import NoMoreData from '@/components/noMoreData.vue';
const store = useStore();
const instance = getCurrentInstance();
export default defineComponent({
  name: 'slideRight',
  components: {
    InputFile,
    Progress,
    NoMoreData
  },
  data() {
    return {
      tabList: [{
        text: '训练资料'
      }, {
        text: '对话信息'
      }],
      // tabList: [{ text: '训练资料' }],
      uploadingList: [],
      contentList: [{
        textName: '小学英语百科常识.pdf',
        img: pdf
      }],
      ac: 0,
      roleDetail: {},
      roleChatList: []
    };
  },
  props: ['roleId'],
  computed: {
    roleList() {
      return this.$store.state.role.onwerAllRoleList;
    },
    isHasUploadingAndList() {
      let uploading = 0;
      this.uploadingList.forEach(item => {
        if (item.roleId === this.roleId) uploading++;
      });
      return uploading || this.contentList.length;
    }
  },
  watch: {
    roleId(n, o) {
      if (n !== o) {
        this.changeItem(this.ac);
      }
    }
  },
  mounted() {
    if (this.roleId) this.changeItem(this.ac);
  },
  setup(props, context) {
    const {
      initAllRoleList,
      getRoleChatMessageMap,
      selectChatOfUuid
    } = roleHooks();
    const {
      uuid
    } = userHooks();
    return {
      initAllRoleList,
      getRoleChatMessageMap,
      selectChatOfUuid,
      uuid
    };
  },
  methods: {
    calcType(name) {
      if (name) {
        let type = name.slice(name.length - 3);
        switch (type) {
          case 'txt':
            return txt;
            break;
          case 'pdf':
            return pdf;
            break;
          default:
            return no;
            break;
        }
        return no;
      }
    },
    changeItem(index) {
      this.ac = index;
      if (this.ac == 0) {
        this.getDetail();
      } else {
        this.getChatMessageMap();
      }
    },
    async getDetail() {
      if (!this.roleId) return;
      const res = await roleDetail({
        id: this.roleId
      });
      console.log('roleDetail', res);
      if (res.code == 200) {
        this.roleDetail = res.data;
        this.contentList = res.data.cRoleInfoDetailsVos.reverse();
      }
    },
    async getChatMessageMap() {
      if (!this.roleId) return;
      const res = await this.getRoleChatMessageMap(this.roleId);
      console.log('chatList', res);
      this.roleChatList = res.records;
    },
    selectChat(item) {
      this.selectChatOfUuid(this.roleId, item.sessionName);
    },
    addChat() {
      this.selectChatOfUuid(this.roleId, '');
    },
    async delSessionChat(item) {
      ElMessageBox.confirm('确认删除该对话？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await deleteSession({
          session: item.sessionName,
          roleId: this.roleId
        });
        this.getChatMessageMap();
        this.uuid == item.sessionName && this.addChat();
      });
    },
    downloadClick(item) {
      console.log(item);
      let url = item.url;
      let type = item.name.slice(item.name.length - 3);
      let list = {
        url,
        name: item.name,
        type
      };
      console.log(list);
      this.downloadType(list);
    },
    pdf1() {
      let url = 'http://test.yxycf.top/1.pdf';
      let list = {
        url,
        name: 'pdf文件',
        type: calcType(item.name)
      };
      this.downloadType(list);
    },
    downloadType(data) {
      switch (data.type) {
        case 'img':
          return this.downloadFile(data);
        case 'pdf':
          return this.downloadFile(data);
        case 'word':
          return this.downloadFile(data);
        case 'txt':
          return this.downloadFile(data);
      }
    },
    downloadFile(data) {
      this.fetchDownloadFile(data);
    },
    async fetchDownloadFile(data) {
      // fetch(data.url, {
      //   method: 'get',
      //   mode: 'cors'
      // })
      // .then((response) => response.blob())
      getFilePort({
        url: data.url,
        fileName: data.name
      }).then(res => {
        const downloadUrl = window.URL.createObjectURL(
        //new Blob() 对后端返回文件流类型处理
        new Blob([res], {
          type: data.type == 'pdf' ? 'application/pdf' : data.type == 'word' ? 'application/msword' : data.type == 'xlsx' ? 'application/vnd.ms-excel' : ''
        }));
        //word文档为msword,pdf文档为pdf
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', data.name);
        document.body.appendChild(link);
        link.click();
        link.remove();
      }).catch(error => {
        window.open(data.url);
      });
    },
    getFiles(files) {
      if (this.roleDetail.roleType != 2) {
        ElMessage.warning({
          message: '此数字人无法更改，请自行创建'
        });
        return;
      }
      console.log('files', files);
      files.forEach((file, index) => {
        let obj = {
          progress: 0,
          name: file.name,
          roleId: this.roleId
        };
        this.uploadingList = [];
        this.uploadingList.push(obj);
        this.uploadPort(obj, file);
      });
    },
    async uploadPort(obj, file) {
      const formData = new FormData();
      formData.append('file', file);
      const url = await upload(formData, res => {
        console.log('upload', res);
        obj.progress = res.progress;
        this.$forceUpdate();
      });
      obj.url = url;
      console.log('url', url);
      this.ChatMessage(obj);
    },
    async ChatMessage(obj) {
      const res = await saveMacChatMessage({
        roleId: obj.roleId,
        url: obj.url
      });
      console.log('res', res);
      this.saveFileport(obj);
    },
    async saveFileport(obj) {
      const res = await saveRoleInfoDetails({
        roleId: obj.roleId,
        name: obj.name,
        url: obj.url
      });
      this.initAllRoleList();
      this.uploadingList.forEach((ele, index) => {
        if (ele.progress === 100) {
          this.uploadingList.splice(index, 1);
        }
      });
      this.getDetail();
      console.log('res', res);
      ElMessage.success({
        message: '成功添加资料'
      });
    },
    async deleteFile(item) {
      console.log(item);
      const res = await delRoleInfoDetails({
        detailsId: item.id
      });
      this.getDetail();
      console.log('res', res);
      ElMessage.success({
        message: '成功删除资料'
      });
    }
  }
});